import Multiselect from 'multiselect-react-dropdown';
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { withTranslation } from "react-i18next";
import { BiChevronRight } from "react-icons/bi";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import UserService from '../../../core/service/UserService';

const UserForm = ({ t, onSaveUser, show }) => {
    const [searchParams] = useSearchParams();
    const userLogin = searchParams.get("login") ?? null;
    const navigate = useNavigate();
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [editDataGroups, setEditDataGroups] = useState([]);
    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState({
        id: 0,
        login: '',
        name: '',
        email: '',
        authorities: [],
        activated: false,
        groups: []
    });
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [allGroups, setAllGroups] = useState([]);

    const handleGroupSelect = (selectedList) => {
        const ids = selectedList.map(item => item.id);
        setSelectedGroups(ids);
    };

    const handleGroupRemove = (selectedList, removedItem) => {
        const updatedGroupIds = selectedList.map(item => item.id);
        setSelectedGroups(updatedGroupIds);
    };

    useEffect(() => {
        UserService.getAllowedRoles().then(res => {
            if (res.status === 200) {
                setAllGroups(res.data?.allGroups);
            }
        }).catch(error => {
            toast.error(error.title, {
                position: toast.POSITION.TOP_RIGHT,
            });
        });
        if (userLogin) {
            UserService.getUserDetails(userLogin).then(res => {
                if (res.status === 200) {
                    setFormData({
                        id: res.data.id,
                        login: res.data.login,
                        name: res.data.name,
                        email: res.data.email,
                        authorities: res.data.authorities,
                        activated: res.data.activated,
                        roles: res.data.roles
                    });
                    setEditDataGroups(res.data.groups);
                }
            }).catch(error => {
                toast.error(error.title, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            })
        }
    }, []);

    useEffect(() => {
        if (editDataGroups && allGroups.length > 0) {
            const groupIdsToSelect = allGroups
                .filter(group => editDataGroups.includes(group.name))
                .map(group => group.id);
            setSelectedGroups(groupIdsToSelect);
        }
    }, [editDataGroups, allGroups]);


    const onSave = () => {
        setValidated(true);
        if (!formData.name || !formData.email) {
            return;
        }
        setSaveInProgress(true);
        const dataToSave = { ...formData };
        delete dataToSave.roles;
        dataToSave.groups = allGroups
        .filter(group => selectedGroups.includes(group.id))
        .map(group => group.name);
        let api;
        if (userLogin) {
            api = UserService.updateUser(dataToSave);
        } else {
            delete dataToSave.id;
            api = UserService.createUser(dataToSave);
        }
        api.then((response) => {
            if (response.status === 201 || response.status === 200) {
                toast.success(t(response.status === 201 ? "UserCreateSuccess.message" : "UserUpdateSuccess.message"), {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: true,
                });
                onSaveUser()

            }
            setSaveInProgress(false);
        }).catch((error) => {
            toast.error(error.title, {
                position: toast.POSITION.TOP_RIGHT,
            });
            setSaveInProgress(false);
        });
    };

    return (
        <>
            <section>
                <div className="Main_body">
                    <div className={show ? "Company_formBox" : "Company_formBox col-lg-6"}>

                        {!(show) && (<div className="List_header">
                            <h5 className="MH">
                                <Link
                                    to="../users"
                                    className="Search_iocnBox">
                                    {t("Users.label")}
                                    <BiChevronRight />
                                </Link>
                                {userLogin !== null ? t("EditUser.label") : t("CreateUser.label")}
                            </h5>
                        </div>)}


                        <Form noValidate validated={validated}>
                            <div className="mb-4 row mx-0">
                                <div className="col-lg-12 p-2">
                                    <label className="mb-1">
                                        {t("Name.label")} *
                                    </label>
                                    <input
                                        required
                                        type="text"
                                        className="form-control"
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
                                </div>
                                <div className="col-lg-12 p-2">
                                    <label className="mb-1">{t("Emailid.label")} *</label>
                                    <input
                                        disabled={userLogin !== null}
                                        type="email"
                                        className="form-control"
                                        value={formData.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value, login: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="col-lg-12 p-2">
                                    <label className="mb-1">{t("Roles.label")} *</label>
                                    {/* Group Selector */}
                                    <Multiselect
                                        options={allGroups
                                            .slice()
                                            .sort((a, b) => a.name.localeCompare(b.name))
                                            .map(({ id, name }) => ({ id, name }))}
                                        selectedValues={allGroups
                                            .filter(({ id }) => selectedGroups.includes(id))
                                            .map(({ id, name }) => ({ id, name }))}
                                        displayValue="name"
                                        required
                                        showArrow={false}
                                        closeOnSelect={false}
                                        onSelect={handleGroupSelect}
                                        onRemove={handleGroupRemove}
                                        style={{ chips: { maxWidth: '200px', whiteSpace: 'normal' } }}
                                    />
                                </div>
                                {
                                    userLogin &&
                                    <div className="col-lg-12 p-2">
                                        <div className="form-check">
                                            <input type="checkbox"
                                                id="disableUserCheckbox"
                                                className="form-check-input"
                                                checked={!formData.activated}
                                                onChange={() => setFormData({ ...formData, activated: !formData.activated })} />
                                            <label className="form-check-label" htmlFor="disableUserCheckbox">
                                                {t("DisableUser.label")}
                                            </label>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="text-center">
                                {!(show) && (<button
                                    type="submit"
                                    className="btn btn-secondary me-2 px-3"
                                    onClick={() => {
                                        navigate('../users');
                                    }}
                                >
                                    {t("Cancel.label")}
                                </button>)}
                                {userLogin !== null
                                    ?
                                    <button type="button" className="btn  btn-primary px-3 sbmBtn" onClick={() => { onSave() }}>
                                        {t("Update.label")}
                                    </button>
                                    :
                                    <button type="button" className="btn  btn-primary px-3 sbmBtn" disabled={saveInProgress} onClick={() => onSave()}>
                                        {saveInProgress
                                            ?
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                            : <>{t("Create.label")}</>
                                        }
                                    </button>}
                            </div>
                        </Form>
                    </div>
                </div>
            </section>
        </>
    );
}

export default withTranslation()(UserForm);